
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 4h-7A1.5 1.5 0 003 5.5v5A1.5 1.5 0 004.5 12h7a1.5 1.5 0 001.5-1.5v-5A1.5 1.5 0 0011.5 4zm-.335 1L8 7.375 4.835 5h6.33zm.335 6h-7a.5.5 0 01-.5-.5V5.625L7.7 8.4a.5.5 0 00.6 0L12 5.625V10.5a.5.5 0 01-.5.5z"}})])
          )
        }
      }
    